import fetch from 'auth/FetchInterceptor'

const StageService = {
  getByPipeline: (pipelineId) =>
    fetch({ url: `/crm/pipelines/${pipelineId}/stages`, method: 'get' }),
  create: (pipelineId, data) =>
    fetch({
      url: `/crm/pipelines/${pipelineId}/stages`,
      method: 'post',
      data,
    }),
  update: (id, data) =>
    fetch({ url: `/crm/stages/${id}`, method: 'patch', data }),
  remove: (id) => fetch({ url: `/crm/stages/${id}`, method: 'delete' }),
  reorder: (pipelineId, stageIds) =>
    fetch({
      url: `/crm/pipelines/${pipelineId}/stages/reorder`,
      method: 'post',
      data: { stageIds },
    }),
}

export default StageService
